import { render, staticRenderFns } from "./BrandShow.vue?vue&type=template&id=4227f6fa&"
import script from "./BrandShow.vue?vue&type=script&lang=js&"
export * from "./BrandShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports